import React, { useEffect } from "react";
import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { Icon } from "@iconify/react";
import AddEditTravllerEssential from "./AddEditTravllerEssential";
import { TravellerEssentialsList } from "./TravellerEssentialList/TravellerEssentialsList";

export const TravellerEssentialsTab: React.FC = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const items = [
    { label: "Overview", key: "travellerEssentialsOverview", children: <AddEditTravllerEssential /> },
    { label: "List", key: "travellerEssentialsList", children: <TravellerEssentialsList /> },
  ];

  
  return (
    <Tabs
        activeKey={query?.get("subActiveTab") || 'travellerEssentialsOverview'}
        items={items}
        onChange={(key) => {
            navigate(`${window.location.pathname}?activeTab=travellerEssentials&subActiveTab=${key}`);
        }}
      />
  );
};